<template>
  <v-card
    class="pa-4 status-card"
    :class="{ 'status-card--light-bg': true }"
    :color="bgColor"
    flat
  >
    <v-card-title class="d-flex justify-space-between align-center status-card__text">
      <span class="text-subtitle-1 font-weight-medium">{{ title }}</span>
      <v-avatar :color="color + ' lighten-4'">
        <v-icon :color="iconColor">{{ icon }}</v-icon>
      </v-avatar>
    </v-card-title>

    <v-card-text class="status-card__text">
      <div class="text-h5 font-weight-bold">{{ count }}</div>

      <div class="d-flex justify-space-between align-center">
        <div class="text-subtitle-1">
          {{ value | toMoney | currency_symbol }}
          ({{ quantity }} items)
        </div>
      </div>

      <div class="text-caption">{{ description }}</div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "statusCard",
  props: {
    title: String,
    count: Number,
    value: Number,
    quantity:Number,
    description: String,
    color: String,
    icon: String,
  },
  computed: {
    bgColor() {
      return `${this.color} lighten-5`;
    },
    iconColor() {
      return `${this.color} darken-2`;
    },
    isLightBackground() {
      return String(this.color).toLowerCase() === "amber";
    },
  },
};
</script>

<style scoped>
.bg-green {
  background-color: #e8f5e9 !important;
}
.bg-amber {
  background-color: #fff3e0 !important;
}
.bg-red {
  background-color: #ffebee !important;
}

.theme--dark .status-card--light-bg .status-card__text,
.theme--dark .status-card--light-bg .v-card__title,
.theme--dark .status-card--light-bg .v-card__text {
  color: rgba(0, 0, 0, 0.6) !important;
}
.theme--dark .status-card--light-bg .v-card__text .text-caption {
  color: rgba(0, 0, 0, 0.6) !important;
}
</style>
